import { Box, CircularProgress } from "@mui/material";
import { lazy, Suspense, useEffect } from "react";
import useAuth from "./hooks/useAuth";
import LoginScreen from "./screens/LoginScreen";
import { isAutomaticOnlyUser } from "./constants/valuationAutomaticCloneRq117_v1";
import "./styles/avmEditorialCaixa.css";

/* RQ-111 — AppLayout (Automatic/Scraping/mapas) fora do bundle inicial do login */
const AppLayout = lazy(() => import("./components/layout/AppLayout"));
const ValuationAutomaticErrorBoundary = lazy(() =>
  import("./components/valuation-automatic/ValuationAutomaticErrorBoundary")
);
const ValuationAutomaticCloneRq117Screen = lazy(() =>
  import("./screens/valuation-automatic-clone-rq117/ValuationAutomaticCloneRq117Screen")
);

function App() {
  const { user, setUser, checkingAuth, logout } = useAuth();
  const isCaixaUser = isAutomaticOnlyUser(user);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (isCaixaUser) {
      document.title = "AVM CAIXA";
      document.documentElement.setAttribute("data-editorial-caixa", "1");
      document.body.setAttribute("data-editorial-caixa", "1");
      if (metaDesc) {
        metaDesc.setAttribute("content", "AVM CAIXA — Avaliação Automática de Imóveis");
      }
    } else if (user) {
      document.title = "BR Engenharia";
      document.documentElement.removeAttribute("data-editorial-caixa");
      document.body.removeAttribute("data-editorial-caixa");
      if (metaDesc) {
        metaDesc.setAttribute(
          "content",
          "BR Engenharia — plataforma de avaliação e engenharia consultiva"
        );
      }
    }
  }, [isCaixaUser, user]);

  if (checkingAuth) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <LoginScreen onLoginSuccess={setUser} />;
  }

  if (isCaixaUser) {
    return (
      <Suspense
        fallback={
          <Box sx={{ textAlign: "center", mt: 10 }}>
            <CircularProgress />
          </Box>
        }
      >
        <ValuationAutomaticErrorBoundary
          onGoHome={undefined}
          onRetry={() => window.location.reload()}
        >
          <ValuationAutomaticCloneRq117Screen
            user={user}
            onExit={null}
            onGoHome={null}
            onLogout={logout}
          />
        </ValuationAutomaticErrorBoundary>
      </Suspense>
    );
  }

  return (
    <Suspense
      fallback={
        <Box sx={{ textAlign: "center", mt: 10 }}>
          <CircularProgress />
        </Box>
      }
    >
      <AppLayout user={user} onLogout={logout} onUserUpdate={setUser} />
    </Suspense>
  );
}

export default App;
